// src/services/notifications/messages.js

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const MESSAGES = {
  streak: {
    risk: [
      { title: "🔥 Não quebre sua sequência!", body: "Sua ofensiva está em risco! Registre uma atividade antes da meia-noite." },
      { title: "⏰ Faltam horas para meia-noite", body: "Você ainda não registrou nada hoje. Salve sua ofensiva agora!" },
      { title: "🚨 Sequência em perigo!", body: "Uma atividade é suficiente para salvar sua ofensiva. Vai lá!" },
      { title: "💪 Você consegue!", body: "Não deixe sua sequência quebrar. Qualquer atividade conta!" },
      { title: "🔥 Sua chama está apagando...", body: "Registre uma atividade e mantenha sua ofensiva viva até meia-noite." },
      { title: "⚡ Último aviso do dia!", body: "Ofensiva em risco. Registre agora e mantenha sua sequência!" },
    ],
    milestone: (days) => pick([
      { title: `🔥 ${days} dias seguidos!`, body: "Incrível! Não deixe quebrar agora 💪" },
      { title: `⚡ ${days} dias de ofensiva!`, body: "Você está mandando muito! Continue assim." },
      { title: `🏆 Sequência de ${days} dias!`, body: "Esse ritmo é o que faz a diferença. Siga em frente!" },
      { title: `🔥 ${days} dias sem parar!`, body: "Sua dedicação é inspiradora. Mantenha o ritmo!" },
    ]),
  },

  workout: {
    before: [
      { title: "🏋️ Hora do treino se aproxima!", body: "Prepare sua roupa, sua água e bora! 💪" },
      { title: "💪 Hoje é dia de treino!", body: "Seu corpo está te esperando. Vamos lá!" },
      { title: "🎯 Foco total hoje!", body: "Cada rep conta para o seu Score VITA. Bora!" },
      { title: "⚡ Energia máxima!", body: "Seu treino está chegando. Dá o melhor hoje?" },
      { title: "🔥 Hora de suar!", body: "Consistência bate motivação. Vai treinar!" },
      { title: "🏅 Ranking não para!", body: "Enquanto você lê isso, alguém está treinando. Bora!" },
    ],
    checkin: [
      { title: "📸 Registrou o treino?", body: "Não esqueça do check-in e garanta seus XP!" },
      { title: "🏅 Seus pontos estão esperando!", body: "Fez o treino? Registre agora e suba no ranking!" },
      { title: "⚡ XP esperando por você!", body: "Registre seu treino e some pontos para o Score VITA." },
      { title: "⚡ Check-in do treino!", body: "Cada treino registrado é um passo a mais no ranking." },
      { title: "🎯 Não perca seus XP!", body: "Treinou? Registre o check-in e mantenha a ofensiva!" },
      { title: "🔥 Ofensiva em jogo!", body: "Registre seu treino para garantir mais um dia na sequência." },
    ],
    noActivity: (days) => {
      // Nunca registrou (valor padrão 999 quando não há data)
      if (days >= 999) return pick([
        { title: "🏋️ Hora de começar!", body: "Registre seu primeiro treino e suba de nível!" },
        { title: "🔥 Seu Score VITA te espera!", body: "Faça seu primeiro check-in de treino e comece a pontuar!" },
        { title: "💪 Primeiro passo é o mais difícil!", body: "Registre uma atividade agora e entre no ranking!" },
        { title: "⚡ Hora de estrear!", body: "Seu primeiro treino registrado te garante XP imediato. Bora!" },
      ]);

      // Passou de 60 dias — mensagem genérica sem número
      if (days > 60) return pick([
        { title: "😴 Já faz tempo que não aparece...", body: "Que tal hoje? Um treino já faz diferença no Score VITA!" },
        { title: "🏋️ Sentimos sua falta!", body: "Volte a registrar seus treinos e recupere sua posição no ranking." },
        { title: "🔥 A melhor hora é agora!", body: "Não importa quanto tempo parou. Registre uma atividade hoje!" },
        { title: "💪 Todo começo é válido!", body: "Retome seus treinos e veja o Score VITA subir de novo." },
      ]);

      // 31-60 dias
      if (days > 30) return pick([
        { title: `😴 Mais de um mês sem treinar...`, body: "Hora de sacudir a poeira! Um treino já reativa sua sequência." },
        { title: "🏋️ O ranking mudou sem você!", body: "Volte a registrar e recupere o tempo perdido. Bora!" },
        { title: "💪 Ainda dá tempo de virar o jogo!", body: "Registre um treino hoje e reactive seu Score VITA." },
      ]);

      // 16-30 dias
      if (days > 15) return pick([
        { title: `😴 ${days} dias de pausa...`, body: "Hora de voltar! Cada treino conta para sua evolução." },
        { title: "🏋️ Saudade de te ver treinar!", body: `${days} dias sem registrar. Que tal hoje?` },
        { title: "💪 O ranking está te esperando!", body: `${days} dias de pausa. Volte e retome sua posição!` },
        { title: "📉 Seu Score VITA sente falta!", body: `${days} dias sem registrar. Um treino já faz diferença!` },
      ]);

      // 3-15 dias — mostra o número normalmente
      return pick([
        { title: `😴 ${days} dias sem treino...`, body: "Hora de voltar! Cada treino conta para sua evolução." },
        { title: "🏋️ Saudade de te ver treinar!", body: `Faz ${days} dias que você não registra. Que tal hoje?` },
        { title: "💪 O ranking está te esperando!", body: `${days} dias de pausa. Volte e retome sua posição!` },
        { title: "🔥 Não perca o ritmo!", body: `${days} dias sem check-in. Um treino agora já faz diferença!` },
      ]);
    },
    planDay: [
      { title: "📋 Hoje é dia de treino!", body: "Seu plano tem atividade para hoje. Vamos lá?" },
      { title: "🎯 Plano do dia!", body: "Você tem um treino agendado para hoje. Bora!" },
      { title: "💪 Seu plano te chama!", body: "Treino no plano de hoje. Não deixa pra amanhã!" },
      { title: "⚡ Cumpra o plano hoje!", body: "Seu treino está programado. Bora conquistar mais XP!" },
    ],
  },

  meal: {
    lunch: [
      { title: "🍽️ Hora do almoço!", body: "Não esqueça de registrar sua refeição e ganhar XP!" },
      { title: "🥗 Registre seu almoço!", body: "Cada foto de refeição vale pontos no Score VITA." },
      { title: "🥗 Almoço registrado?", body: "Bate uma foto da refeição e some XP para o ranking!" },
      { title: "🥗 XP no prato!", body: "Fotografe seu almoço e ative sua área de Dieta." },
      { title: "🍱 Hora de comer e pontuar!", body: "Registre seu almoço agora. Cada refeição conta!" },
      { title: "🥗 Dieta em dia?", body: "Bate a foto do almoço e mantém seu Score VITA forte!" },
    ],
    dinner: [
      { title: "🌙 Hora da janta!", body: "Registre sua refeição da noite e feche o dia no verde!" },
      { title: "🍽️ Janta chegando!", body: "Não esqueça de bater a foto e garantir seus XP noturnos." },
      { title: "📸 Última refeição do dia!", body: "Registre sua janta e complete seu histórico alimentar de hoje." },
      { title: "⭐ Feche o dia forte!", body: "Janta chegando — registre e mantenha o Score VITA ativo." },
      { title: "🌙 Finalize o dia direitinho!", body: "Uma foto da janta e seu dia de dieta está completo." },
    ],
    missedLunch: [
      { title: "🍽️ Esqueceu o almoço?", body: "Você registrou antes mas o almoço ficou de fora. Ainda dá tempo!" },
      { title: "📸 Foto do almoço!", body: "Você registrou o café mas esqueceu o almoço. Bate a foto agora!" },
    ],
    missedDinner: [
      { title: "🌙 Janta registrada?", body: "Feche o dia registrando sua última refeição. Vale XP!" },
      { title: "📸 Última chance hoje!", body: "Não esqueça da janta! Cada refeição registrada conta." },
    ],
  },

  xp: {
    closeToLevelUp: (xpNeeded, nextLevel) => pick([
      { title: "⚡ Quase lá!", body: `Faltam apenas ${xpNeeded} XP para o Nível ${nextLevel}! Que tal um treino rápido?` },
      { title: `🏅 Nível ${nextLevel} à vista!`, body: `Só ${xpNeeded} XP te separam do próximo nível. Vai lá!` },
      { title: "🎯 Sobe de nível hoje!", body: `${xpNeeded} XP e você chega ao Nível ${nextLevel}. Registre uma atividade!` },
      { title: `⭐ Tão perto do Nível ${nextLevel}!`, body: `${xpNeeded} XP apenas! Uma refeição ou treino já resolve.` },
    ]),
  },

  // FCM — gerado no backend, mas templates aqui para referência
  ranking: {
    overtaken: (name) => pick([
      { title: "📉 Você foi ultrapassado!", body: `${name} está à sua frente agora. Reaja e retome sua posição!` },
      { title: "⚠️ Posição perdida!", body: `${name} te ultrapassou no ranking. Hora de reagir!` },
    ]),
    competitionEnding: (days, position) => pick([
      { title: "⏰ Competição acabando!", body: `Faltam ${days} dias e você está em ${position}º. Dá tempo de subir!` },
      { title: "🏆 Últimos dias da competição!", body: `${days} dias restantes. Você está em ${position}º lugar. Bora!` },
    ]),
    weekEnding: (position) => pick([
      { title: "📅 Semana quase acabando!", body: `Você está em ${position}º. Ainda dá para subir no ranking semanal!` },
      { title: "⚡ Último dia da semana!", body: `${position}º lugar por agora. Um treino pode te fazer subir!` },
    ]),
  },

  // Convite para criar/entrar num clube (agendado só para quem ainda não está
  // em nenhum — ver scheduleClubInvite). Tom de convite, não de cobrança.
  clubes: {
    convite: [
      { title: "Bora montar um time? 🏆", body: "Crie um clube, chame os amigos e descubram quem treina mais nesta semana." },
      { title: "Família que treina junto… 💪", body: "…fica junto. Monte um clube no LesVita e transforme a saúde da galera num jogo." },
      { title: "Seu rival favorito está te esperando 😏", body: "Crie um clube, mande o link e deixe o ranking falar por vocês." },
      { title: "Competição saudável, versão divertida 🎉", body: "No clube, cada treino e refeição vira ponto. Quem da sua turma topa?" },
      { title: "Treinar sozinho cansa. Em grupo, vicia. 🔥", body: "Crie seu clube em 1 minuto e convide quem você quer ver mais saudável." },
      { title: "Desafio entre amigos? Tá liberado 🚀", body: "Monte um clube, chame a galera e vejam quem chega no topo do ranking." },
    ],
  },

  score: {
    dropped: (score) => pick([
      { title: "📉 Score VITA caiu!", body: `Seu Score VITA está em ${score}. Veja o que melhorar no app.` },
      { title: "⚠️ Score VITA em queda", body: `Pontuação atual: ${score}. Registre treinos e refeições para subir!` },
    ]),
    areaInactive: (area) => pick([
      { title: `📊 Área de ${area} inativa!`, body: `Registre uma atividade de ${area.toLowerCase()} para ativar seu Score VITA.` },
      { title: `⚠️ ${area} pendente no Score!`, body: `Sua área de ${area} não está computando. Ative agora!` },
    ]),
  },
};

export { pick };